import { ArrowLeftIcon } from '@vizit/icons';
import { RouterButtonLink, RouterButtonLinkLevel } from '@vizit/molecules';
import { colors, cx } from '@vizit/theme';
import * as React from 'react';

interface BackToNavbarProps extends React.PropsWithChildren {
  className?: string;
  /**
   * The name of the previous page from the history state.
   * ```tsx
   * const location = useLocation();
   * const { previousPageName } = location.state ?? {};
   * ```
   * @default 'Previous Page'
   */
  previousPageName?: string;
  /**
   * The path to navigate to when the back button is pressed.
   *
   * @default '/'
   */
  to: string;
  /**
   * The search parameters to navigate to when the back button is pressed.
   *
   * @optional
   */
  search?: Record<string, unknown>;
}

const BackToNavbar = React.forwardRef<HTMLElement, BackToNavbarProps>((props, ref) => {
  const { previousPageName = 'Previous Page', to, className, search } = props;

  return (
    <nav ref={ref} className={cx('w-full bg-white border-b border-primary py-4 px-8', className)}>
      <div className={cx('h-18 flex items-center justify-between')}>
        <RouterButtonLink
          className="font-semibold"
          level={RouterButtonLinkLevel.Ghost}
          iconStart={<ArrowLeftIcon size={20} color={colors['gray-utility'][400]} />}
          to={to}
          search={search}
        >
          {`Back to ${previousPageName.toLowerCase()}`}
        </RouterButtonLink>
      </div>
    </nav>
  );
});

export { BackToNavbar };
